const malformedListRegex = /^(?![#>])(.*)\n-\n/gm;
function fixMalformedLists(markdown) {
  return markdown.replace(malformedListRegex, "- $1\n");
}

export { fixMalformedLists };
//# sourceMappingURL=fixMalformedLists.js.map
